export default __webpack_public_path__ + "static/media/icon-success.2451dc7b.svg";